import { MemoryObserver } from '@dateam/ark';

class UnauthorizedProvider extends MemoryObserver<boolean> {
    notify(silent: boolean = false) {
        super.notify(silent);
    }
}

export default new UnauthorizedProvider();